export type TransactionProductCategory =
  | "PARTNER_ADHESION"
  | "ASSOCIATE_PREMIUM";

export function formatTransactionProductCategory(
  category?: TransactionProductCategory | null,
): string {
  if (category === "PARTNER_ADHESION") {
    return "Adesão de parceiro";
  }

  if (category === "ASSOCIATE_PREMIUM") {
    return "Assinatura premium de associado";
  }

  return "";
}

export function transactionProductCategoryColor(
  category?: TransactionProductCategory | null,
): string {
  if (category === "PARTNER_ADHESION") {
    return "deep-purple";
  }

  if (category === "ASSOCIATE_PREMIUM") {
    return "teal darken-1";
  }

  return "grey";
}
